export const RouteNames = {
  login: "/login",
  register: "/register",
  forgotPassword: "/forgot-password",
  resetPassword: "/reset-password",
  calendar: "/",
  properties: "/properties",
  reservations: "/reservations",
  guests: "/guests",
  statistics: "/statistics",
  team: "/team",
  cleaningTasks: "/cleaning-tasks",
  invoices: "/invoices",
  subscription: "/subscription",
  menu: "/menu",
  profile: "/profile",
  support: "/support",
} as const;
